import React, { useState } from "react";
import OfflineBanner from "./OfflineBanner";

export default function AppLayout({ sidebar, children, mainClassName = "" }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const closeSidebar = () => setSidebarOpen(false);

  return (
    <div className="app-layout">
      <OfflineBanner />
      <button
        type="button"
        className="mobile-nav-toggle"
        onClick={() => setSidebarOpen((prev) => !prev)}
        aria-label="Toggle navigation menu"
      >
        ☰
      </button>
      <aside className={sidebarOpen ? "sidebar-shell open" : "sidebar-shell"}>
        {React.cloneElement(sidebar, { onMobileClose: closeSidebar })}
      </aside>
      {sidebarOpen ? (
        <button type="button" className="sidebar-overlay" onClick={closeSidebar} />
      ) : null}
      <main className={`chat-main${mainClassName ? ` ${mainClassName}` : ""}`}>{children}</main>
    </div>
  );
}
